import { SOURCE } from '@meiqia/constants';
import { startsWith } from 'lodash';
import DEFAULT_AVATAR from '@meiqia/static/img/default-avatar.png';
import MINI_PROGRAM from '@meiqia/static/img/mini_program.png';
import parseUrl from '../parse-url';

const { parseQueryStringObj } = parseUrl;
const { DIRECT, REFERRAL, SEARCH, OPENCENTER, searchListSource, openListSource } = SOURCE;

const getSource = k => (k ? k.toLowerCase().replace(/(\s|\.)+/g, '-') : '');

// * 前端需要处理不同的渠道显示成不同的默认头像
const createAvatar = visit_info => {
  const {
    sourceInfo: { type, searchEngine } = {
      type: '',
      searchEngine: ''
    },
    sdk_image_url,
    platform,
    source_source = ''
  } = visit_info;

  // * 兼容顾客界面没有返回first相关字段的问题 通过source_source 字段判断
  let avatar = {
    type: 'image',
    src: [type, source_source].includes('mini_program') ? MINI_PROGRAM : DEFAULT_AVATAR
  };

  if (startsWith(visit_info?.avatar || '', 'http')) {
    avatar = {
      type: 'image',
      src: visit_info?.avatar
    };
  } else if (visit_info?.avatar && startsWith(visit_info?.avatar?.src || '', 'http')) {
    avatar = {
      type: 'image',
      src: visit_info?.avatar?.src
    };
  } else {
    switch (type) {
      case 'sdk':
        if (sdk_image_url) {
          avatar = {
            type: 'image',
            src: sdk_image_url
          };
        } else {
          let src = type;
          // 设备系统
          src = visit_info?.os_family?.toLowerCase() || '';
          avatar = {
            type: 'icon-svg',
            src
          };
        }
        break;
      case 'weixin':
      case 'weibo':
      case 'kuaishou':
      case 'toutiao_microapp':
      case 'toutiao':
      case 'baidu_bcp':
      case 'douyin':
      case 'redbook':
        if (sdk_image_url) {
          avatar = {
            type: 'image',
            src: sdk_image_url
          };
        } else {
          avatar = {
            type: 'type',
            src: type
          };
        }
        break;
      case 'searchEngine':
        avatar = {
          type: 'icon-svg',
          src: searchEngine
        };
        break;
      default:
        // 如果找不到则从平台来源来找
        const scrMap = {
          pc: 'computer',
          mobile: 'phone',
          tablet: 'phone',
          other: 'unknown'
        };
        if (platform) {
          avatar = {
            type: 'icon-svg',
            // 一切的一切是为了展示的时候拼接 class
            src: scrMap[platform]
          };
        }
        break;
    }
  }

  return avatar;
};

function createSource(visitor = {}) {
  if (visitor?.first_visit_page_source_by_session === 'sm.cn') {
    visitor.first_visit_page_source_by_session = 'sm';
  }
  const { first_visit_page_source_by_session = '', first_visit_page_source_url_by_session = '' } = visitor;
  let sourceInfo = {};
  // 第三方平台
  if (openListSource.includes(first_visit_page_source_by_session)) {
    sourceInfo.type = first_visit_page_source_by_session;
    sourceInfo.source = OPENCENTER;
    sourceInfo.subSource = first_visit_page_source_by_session;
    // 搜索引擎
  } else if (searchListSource.includes(getSource(first_visit_page_source_by_session || ''))) {
    sourceInfo.type = 'searchEngine';
    sourceInfo.searchEngine = getSource(first_visit_page_source_by_session || '');
    sourceInfo.source = SEARCH;
    sourceInfo.subSource = first_visit_page_source_by_session;
    // 第三方链接
  } else if (first_visit_page_source_url_by_session) {
    sourceInfo.type = 'referral';
    sourceInfo.source = REFERRAL;
    // 直接访问
  } else {
    sourceInfo.type = 'direct';
    sourceInfo.source = DIRECT;
  }
  return sourceInfo;
}

/**
 * 从着陆页中初始化 utm 信息
 */
function initUtm(page) {
  const queryData = parseQueryStringObj(page);
  return {
    utm_source: queryData.utm_source,
    utm_medium: queryData.utm_medium,
    utm_term: queryData.utm_term,
    utm_content: queryData.utm_content,
    utm_campaign: queryData.utm_campaign
  };
}

/**
 * 初始化一条在线访客数据或者是一条对话的visit_info
 */
function initVisitor(visitor = {}) {
  visitor.sourceInfo = createSource(visitor);
  visitor.utm = initUtm(visitor?.first_visit_page_url_by_session);
  visitor.avatar = createAvatar(visitor);

  return visitor;
}

export default initVisitor;
